export default "__VITE_ASSET__Bpkesi5t__"